import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React__default from 'react';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import 'prop-types';
import '../stringSet-b60e9529.js';
var ReactionBadge = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    children = props.children,
    _props$count = props.count,
    count = _props$count === void 0 ? '' : _props$count,
    _props$isAdd = props.isAdd,
    isAdd = _props$isAdd === void 0 ? false : _props$isAdd,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? function () {/* noop */} : _props$onClick;
  var getClassNameTail = function getClassNameTail() {
    if (selected && !isAdd) {
      return '--selected';
    }
    if (isAdd) {
      return '--is-add';
    }
    return '';
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), ["sendbird-reaction-badge".concat(getClassNameTail())]).join(' '),
    role: "button",
    ref: ref,
    onClick: onClick,
    onKeyDown: onClick,
    onTouchEnd: onClick,
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-reaction-badge__inner"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-reaction-badge__inner__icon"
  }, children), /*#__PURE__*/React__default.createElement(Label, {
    className: children && count && 'sendbird-reaction-badge__inner__count',
    type: LabelTypography.CAPTION_3,
    color: LabelColors.ONBACKGROUND_1
  }, count)));
});
export { ReactionBadge as default };